import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
// eslint-disable-next-line no-unused-vars
import ReactCountryFlag from 'react-country-flag'
import useDropdownMenu from 'react-accessible-dropdown-menu-hook'

export function Navbar() {
	const { t, i18n } = useTranslation()
	const { buttonProps, itemProps, isOpen, setIsOpen } = useDropdownMenu(2)
	const [navBackground, setNavBackground] = useState(false)
	const navRef = useRef()
	// eslint-disable-next-line no-unused-vars
	const [languages, setLanguages] = useState([
		{ countryCode: 'GB', i18nCode: 'en', name: 'English' },
		{ countryCode: 'FR', i18nCode: 'fr', name: 'Français' },
		{ countryCode: 'ES', i18nCode: 'es', name: 'español' },
		{ countryCode: 'IN', i18nCode: 'hi', name: 'हिंदी' },
		{ countryCode: 'CN', i18nCode: 'zh', name: '漢語' },
	])
	const [selectedLanguage, setSelectedLanguage] = useState(
		languages.find((language) => language.i18nCode === i18n.languages[0])
	)
	navRef.current = navBackground
	useEffect(() => {
		document.addEventListener('scroll', handleScroll)
		return () => {
			document.removeEventListener('scroll', handleScroll)
		}
	}, [])

	const handleScroll = () => {
		const show = window.scrollY > 50
		if (navRef.current !== show) {
			setNavBackground(show)
		}
	}
	const handleLanguageSwitching = (language) => {
		setIsOpen(false)
		setSelectedLanguage(language)
		i18n.changeLanguage(language.i18nCode)
	}
	//Javascript to toggle the menu

	const OpenMenu = () => {
		document.getElementById('nav-content').classList.toggle('hidden')
		setNavBackground(true)
	}

	return (
		<nav
			className='w-full flex flex-wrap items-center justify-between p-2 fixed z-50 '
			style={{
				transition: '1s ease',
				backgroundColor: navBackground ? 'white' : 'transparent',
				color: navBackground ? 'black' : 'white',
			}}
		>
			<div className='container px-4 mx-auto flex flex-wrap items-center justify-between'>
				<div className='w-full flex justify-between lg:w-auto lg:static lg:block lg:justify-start'>
					<a className='leading-relaxed inline-block mr-4 py-2 ' href='/'>
						<img
							src='img/logo.png'
							alt='Logo'
							width='110'
							className='max-w-full h-auto align-middle border-none'
						/>
					</a>
					<div className='block lg:hidden'>
						<button
							onClick={OpenMenu}
							id='nav-toggle'
							className='flex items-center px-3 py-2 border rounded text-main-secondary border-main-primary'
						>
							<svg
								className='fill-current w-6'
								viewBox='0 0 20 20'
								xmlns='http://www.w3.org/2000/svg'
							>
								<title>Menu Betish</title>
								<path d='M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z' />
							</svg>
						</button>
					</div>
				</div>
				<div className='lg:flex flex-grow items-center hidden' id='nav-content'>
					<ul className='flex flex-col lg:flex-row list-none lg:ml-auto '>
						<li className='nav-item'>
							<a
								className='px-3 py-2 flex items-center text-lg'
								href='#tournaments'
							>
								<span className='ml-2'>
									{t('translation:navbar:tournaments')}
								</span>
							</a>
						</li>
						<li className='nav-item'>
							<a
								className='px-3 py-2 flex items-center text-lg'
								href='#participation'
							>
								<span className='ml-2'>{t('translation:navbar:how_to')}</span>
							</a>
						</li>
						<li className='nav-item'>
							<a
								className='px-3 py-2 flex items-center text-lg'
								href='#competitions'
							>
								<span className='ml-2'>
									{t('translation:navbar:competitions')}
								</span>
							</a>
						</li>
						<li className='nav-item'>
							<a
								className='px-3 py-2 flex items-center text-lg'
								href='#championship'
							>
								<span className='ml-2'>
									{t('translation:navbar:championship')}
								</span>
							</a>
						</li>
						<li className='nav-item'>
							<a className='h-full relative px-3 flex items-center flex-wrap text-xs'>
								<span className='ml-2 flex items-center'>
									<button {...buttonProps}>
										<ReactCountryFlag
											countryCode={selectedLanguage.countryCode}
											svg
											style={{
												width: '2.5em',
												height: '2.5em',
											}}
											title={selectedLanguage.name}
										/>
									</button>
									<div
										className={
											isOpen ? 'visible absolute mt-40' : 'absolute mt-40'
										}
										role='menu'
									>
										{languages
											.filter(
												(language) =>
													language.i18nCode !== selectedLanguage.i18nCode
											)
											.map((language, index) => (
												<span
													key={index}
													className='w-full flex justify-center'
												>
													<ReactCountryFlag
														{...itemProps[index]}
														key={index}
														countryCode={language.countryCode}
														className='block'
														onClick={() => handleLanguageSwitching(language)}
														svg
														style={{
															width: '2.5em',
															height: '2.5em',
														}}
														title={language.name}
													/>
												</span>
											))}
									</div>
								</span>
							</a>
						</li>
					</ul>
				</div>
			</div>
		</nav>
	)
}
